import { render, staticRenderFns } from "./cameramodalcreate.component.html?vue&type=template&id=6accfbaa&scoped=true&"
import script from "./cameramodalcreate.component.ts?vue&type=script&lang=ts&"
export * from "./cameramodalcreate.component.ts?vue&type=script&lang=ts&"
import style0 from "./cameramodalcreate.component.scss?vue&type=style&index=0&id=6accfbaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6accfbaa",
  null
  
)

export default component.exports